import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { PersonalizationBannerComponent } from "./personalization-banner.component";



@NgModule({
  declarations: [PersonalizationBannerComponent],
  imports: [
    CommonModule,
    BrowserModule
  ],
  exports: [PersonalizationBannerComponent]
})
export class PersonalizationBannerModule { }
